import { Permission } from 'api';
import { RouteDefinition } from './types';

export const getExaminersRoutes = (basePath: string) => ({
  list: {
    to: basePath,
    path: basePath,
    requiresAll: [Permission.FindExaminer],
  } as RouteDefinition,
  certificationExpiredList: {
    to: `${basePath}/:certificationType/certification-expired`,
    path: `${basePath}/:certificationType/certification-expired`,
    requiresAll: [Permission.FindExaminer],
  } as RouteDefinition,
  certificationExpireSoonList: {
    to: `${basePath}/:certificationType/certification-expire-soon`,
    path: `${basePath}/:certificationType/certification-expire-soon`,
    requiresAll: [Permission.FindExaminer],
  } as RouteDefinition,
  monitoringExpiredList: {
    to: `${basePath}/:certificationType/monitoring-expired`,
    path: `${basePath}/:certificationType/monitoring-expired`,
    requiresAll: [Permission.FindExaminer],
  } as RouteDefinition,
  monitoringExpireSoonList: {
    to: `${basePath}/:certificationType/monitoring-expire-soon`,
    path: `${basePath}/:certificationType/monitoring-expire-soon`,
    requiresAll: [Permission.FindExaminer],
  } as RouteDefinition,
  trainingNotCompletedList: {
    to: `${basePath}/:certificationType/training-not-completed`,
    path: `${basePath}/:certificationType/training-not-completed`,
    requiresAll: [Permission.FindExaminer],
  } as RouteDefinition,
  trainingUpcomingList: {
    to: `${basePath}/:certificationType/training-upcoming`,
    path: `${basePath}/:certificationType/training-upcoming`,
    requiresAll: [Permission.FindExaminer],
  } as RouteDefinition,
  add: {
    to: `${basePath}/add`,
    path: `${basePath}/add`,
    requiresAll: [Permission.AddNewExaminer],
  } as RouteDefinition,
});
